/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let prev = 0;

window.addEventListener("scroll", function () {
  const scrollTop = window.scrollY;
  const navbar = document.querySelector(".nav-bar .container");
  const header = document.querySelector(".header--inline");

  if (scrollTop > prev) {
    navbar.classList.add("et-hide");
    header.classList.add("et-padding-bottom");
  } else {
    navbar.classList.remove("et-hide");
    header.classList.remove("et-padding-bottom");
  }
  // prev = scrollTop;
});

function setCardHeightBasedOnVideoExists() {
  const cardSection = document.querySelector(
    ".product-block-list__item--info .card__section"
  );
  if (cardSection && window.screen.innerWidth > 768) {
    if (document.querySelector(".video__section")) {
      cardSection.style.height = "560px";
    } else {
      cardSection.style.height = "585px";
    }
  }
}

if (window.screen.width >= 768) {
  setCardHeightBasedOnVideoExists();
}

$(document).ready(function () {
  function isVisible($el) {
    if ($el && $el.offset()) {
      let docViewTop = $(window).scrollTop();
      let docViewBottom = docViewTop + $(window).height();
      let elTop = $el.offset().top;
      let elBottom = elTop + $el.height();
      return elBottom <= docViewBottom && elTop >= docViewTop;
    } else {
      return false;
    }
  }

  function showCartButtonOnMobile() {
    const mobileCartButton = $(".cart-recap__checkout--default");
    const mobileCartButtonFixed = $(".cart-recap--fixed");
    const mobileCartButtonFixedActiveClass = "cart-recap--active";

    if (window.screen.width <= 768) {
      if (mobileCartButton) {
        if (!isVisible(mobileCartButton)) {
          mobileCartButtonFixed.addClass(mobileCartButtonFixedActiveClass);
        } else {
          mobileCartButtonFixed.removeClass(mobileCartButtonFixedActiveClass);
        }
      }
    }
  }

  function showPaymentButtonOnMobile() {
    const mobilePaymentButton = $(".product-form__featured-container");
    const mobilePaymentButtonFixed = $(".product-form__payment-container--fixed");
    const desktopPaymentButton = $(".c-product-buy-button__wrapper");
    
    const mobilePaymentButtonFixedActiveClass = "product-form__payment-container--active";
    const desktopPaymentButtonFixedActiveClass = "c-product-buy-button__wrapper--active";

    if (window.screen.width <= 768) {
      if (mobilePaymentButton) {
        if (!isVisible(mobilePaymentButton)) {
          mobilePaymentButtonFixed.addClass(mobilePaymentButtonFixedActiveClass);
        } else {
          mobilePaymentButtonFixed.removeClass(mobilePaymentButtonFixedActiveClass);
        }
      }
    } else {
      if (desktopPaymentButton) {
        if (!isVisible(mobilePaymentButton)) {
          desktopPaymentButton.addClass(desktopPaymentButtonFixedActiveClass);
        } else {
          desktopPaymentButton.removeClass(desktopPaymentButtonFixedActiveClass);
        }
      }
    }
  }

  function showPaymentButtonOnScroll(callback) {
    window.addEventListener("scroll", (event) => {
      requestAnimationFrame(callback);
    });
  }
  
  showPaymentButtonOnScroll(showPaymentButtonOnMobile);
  showPaymentButtonOnScroll(showCartButtonOnMobile);

  window.addEventListener("resize", () => {

  })

  const handleReturnIframe = () => {
    const returnIframe = document.getElementById("orderLookupIframe");
    if (returnIframe) {
      returnIframe.setAttribute("scrolling", "yes");
    }
  };

  handleReturnIframe();
});
